import { Eye, EyeSlash } from "@phosphor-icons/react";

/* Tiny eye toggle for attachment tiles: shown-to-client (default) vs hidden. `hidden` = file.client_visible === false. */
export function ClientVisibilityBadge({ hidden, onToggle, index }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      title={hidden ? "Hidden from the client portal — click to show" : "Visible in the client portal — click to hide"}
      className={`h-5 w-5 rounded-full flex items-center justify-center shadow ${hidden ? "bg-slate-700 text-white" : "bg-emerald-500/90 text-white"}`}
      data-testid={`client-visibility-${index}`}
    >
      {hidden ? <EyeSlash size={11} weight="bold" /> : <Eye size={11} weight="bold" />}
    </button>
  );
}

/* Flip client_visible on files[index] (true ↔ false). Returns the new array. */
export const toggleFileVisibility = (files, index) => files.map((f, i) => (i === index ? { ...f, client_visible: f.client_visible === false } : f));
